<template>
    <div class="pdf-preview">
        <slot></slot>
        <div class="pdf-preview__content">
            <iframe :src="url" width="100%" height="700px" frameborder="0"></iframe>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            url: { type: String, default: undefined },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';

    .pdf-preview {
        position: fixed;
        display: block;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: $color-black;
        align-items: center;
        justify-content: center;
        overflow: auto;
        z-index: 25;
        background-color: $pdf-preview-grayish-blue;

        &__content {
            width: 100%;
            height: 100%;
        }
    }
</style>
